import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="prisma-footer" data-testid="footer">
      <div className="footer-inner">
        <div className="footer-top">
          <div className="footer-brand-col">
            <img src="/prisma-logo-white.png" alt="Prisma Global" className="footer-logo" />
            <p className="footer-brand-statement">
              Prisma Global is a multi-venture ecosystem designed to build, scale, and systemize ideas into long-term assets.
            </p>
          </div>

          <div className="footer-col">
            <h4 className="footer-col-title">Ventures</h4>
            <a href="/ventures" className="footer-link">Digital &amp; Campaign Services</a>
            <a href="/ventures" className="footer-link">Eco-Warriors&trade;</a>
            <a href="/ventures" className="footer-link">Discover Solapur&trade;</a>
            <a href="/ventures" className="footer-link">PrismaTex</a>
            <a href="/ventures" className="footer-link">Prisma Terra</a>
            <a href="/ventures" className="footer-link">Prisma Studio</a>
          </div>

          <div className="footer-col">
            <h4 className="footer-col-title">Company</h4>
            <a href="/founder" className="footer-link">Founder</a>
            <a href="/impact" className="footer-link">Impact</a>
            <a href="/press" className="footer-link">Press</a>
            <a href="/contact" className="footer-link">Contact</a>
          </div>

          <div className="footer-col">
            <h4 className="footer-col-title">Connect</h4>
            <a href="https://www.instagram.com/prisma.global5/" target="_blank" rel="noopener noreferrer" className="footer-link">Instagram</a>
            <a href="https://www.linkedin.com/in/vedavati-lolge-58412862/" target="_blank" rel="noopener noreferrer" className="footer-link">LinkedIn</a>
            <a href="mailto:info@theprismaglobal.com" className="footer-link">info@theprismaglobal.com</a>
            <a href="tel:+919356107460" className="footer-link">+91 9356 107 460</a>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-bottom-left">
            <span>&copy; {new Date().getFullYear()} The Prisma Global. Solapur, India.</span>
          </div>
          <div className="footer-legal-links">
            <a href="/terms-conditions">Terms</a>
            <a href="/privacy-policy">Privacy</a>
            <a href="/refund-policy">Refund Policy</a>
          </div>
        </div>

        <div className="footer-msme-bar" data-testid="footer-msme">
          MSME Registered &nbsp;|&nbsp; UDYAM-MH-32-0255914
        </div>
      </div>
    </footer>
  );
};

export default Footer;
